
const state = {
  menuList: [
    {
      // title:'Home',
      title: "홈페이지",
      // title: this.$t("map.home"),
      path: "home",
      auth: true,
      type: "home.png",
    },
    {
      // title:'Login',
      title: "로그인",
      // title: this.$t("map.login"),
      path: "login",
      auth: true,
      type: "login.png",
    },
    {
      //   title: "With friends",
      title: "연맹",
      // title: this.$t("map.withfriends"),
      path: "friends",
      auth: true,
      type: "friends.png",
    },
    {
      //   title: "Subscribe",
      title: "구독하다",
      // title: this.$t("map.subscribe"),
      path: "subscribe",
      auth: true,
      type: "subscribe.png",
    },
    {
      //   title: "After Sales",
      title: "고객센터",
      // title: this.$t("map.aftersales"),
      path: "aftersales",
      auth: true,
      type: "aftersales.png",
    },
    {
      title:'getNfcode',
      // title: "홈페이지",
      // title: this.$t("map.home"),
      path: "nfcode",
      auth: true,
      type: "excode.png",
    },
    {
      //   title: "luckdraw",
      title: "추첨",
      // title: this.$t("map.luckdraw"),
      path: "luckdraw",
      auth: true,
      type: "luckdraw.png",
    },
    // {
    //     title:'Wish',
  //       title: this.$t("map.wish"),
    //     path:'wish',
    //     auth:true,
    //     type:'wish.png'
    // },
    // {
    //   title: "Help Center",
    //   title: this.$t("map.helpcenter"),
    //   path: "help",
    //   auth: true,
    //   type: "help.png",
    // },
    {
      //   title: "trading stamps",
      title: "환전",
      // title: this.$t("map.tradingstamps"),
      path: "excode",
      auth: true,
      type: "excode.png",
    },
  ],
  menuListNoLogin: [
    {
      // title:'Home',
      title: "메인 화면",
      // title: this.$t("map.home"),
      path: "home",
      auth: true,
      type: "home.png",
    },
    {
      // title:'Login',
      title: "로그인",
      // title: this.$t("map.login"),
      path: "login",
      auth: true,
      type: "login.png",
    },
    {
      //   title: "With friends",
      title: "추천 할인",
      // title: this.$t("map.withfriends"),
      path: "friends",
      auth: true,
      type: "friends.png",
    },
    {
      //   title: "Subscribe",
      title: "구독",
      // title: this.$t("map.subscribe"),
      path: "subscribe",
      auth: true,
      type: "subscribe.png",
    },
    {
      //   title: "After Sales",
      title: "고객센터",
      // title: this.$t("map.aftersales"),
      path: "aftersales",
      auth: true,
      type: "aftersales.png",
    },
    {
      title:'getNfcode',
      // title: "홈페이지",
      // title: this.$t("map.home"),
      path: "nfcode",
      auth: true,
      type: "excode.png",
    },
    {
      //   title: "luckdraw",
      title: "럭키 드로우",
      // title: this.$t("map.luckdraw"),
      path: "luckdraw",
      auth: true,
      type: "luckdraw.png",
    },
    // {
    //     title:'Wish',
    //       title: this.$t("map.wish"),
    //     path:'wish',
    //     auth:true,
    //     type:'wish.png'
    // },
    // {
    //   title: "Help Center",
    //   title: this.$t("map.helpcenter"),
    //   path: "help",
    //   auth: true,
    //   type: "help.png",
    // },
    {
      //   title: "trading stamps",
      title: "쿠폰 사용",
      // title: this.$t("map.tradingstamps"),
      path: "excode",
      auth: true,
      type: "excode.png",
    },
  ],
  // 韩语
  menuListLogin: [
    {
      // title:'Home',
      title: "메인 화면",
      // title: this.$t("map.home"),
      path: "home",
      auth: true,
      type: "home.png",
    },
    {
      // title:'User info',
      title: "사용자 정보",
      // title: this.$t("map.userinfo"),
      path: "userinfo",
      auth: true,
      type: "login.png",
    },
    {
      //   title: "With friends",
      title: "추천 할인",
      // title: this.$t("map.withfriends"),
      path: "friends",
      auth: true,
      type: "friends.png",
    },
    {
      //   title: "Subscribe",
      title: "구독",
      // title: this.$t("map.subscribe"),
      path: "subscribe",
      auth: true,
      type: "subscribe.png",
    },
    {
      //   title: "After Sales",
      title: "고객센터",
      // title: this.$t("map.aftersales"),
      path: "aftersales",
      auth: true,
      type: "aftersales.png",
    },
    {
      title:'getNfcode',
      // title: "홈페이지",
      // title: this.$t("map.home"),
      path: "nfcode",
      auth: true,
      type: "excode.png",
    },
    {
      //   title: "luckdraw",
      title: "럭키 드로우",
      // title: this.$t("map.luckdraw"),
      path: "luckdraw",
      auth: true,
      type: "luckdraw.png",
    },
    // {
    //     title:'소원',
    //       title: this.$t("map.wish"),
    //     path:'wish',
    //     auth:true,
    //     type:'wish.png'
    // },
    // {
    //   title: "Help Center",
    //   title: this.$t("map.helpcenter"),
    //   path: "help",
    //   auth: true,
    //   type: "help.png",
    // },
    {
      //   title: "trading stamps",
      title: "쿠폰 사용",
      // title: this.$t("map.tradingstamps"),
      path: "excode",
      auth: true,
      type: "excode.png",
    },
  ],
// 阿拉伯语
  menuListLoginAr: [
  {
    // title:'Home',
    title: "الصفحة الرئيسية",
    // title: this.$t("map.home"),
    path: "home",
    auth: true,
    type: "home.png",
  },
  {
    // title:'User info',
    title: "معلومات المستخدم",
    // title: this.$t("map.userinfo"),
    path: "userinfo",
    auth: true,
    type: "login.png",
  },
  {
    //   title: "With friends",
    title: "معلومات العمولة",
    // title: this.$t("map.withfriends"),
    path: "friends",
    auth: true,
    type: "friends.png",
  },
  {
    //   title: "Subscribe",
    title: "الاشتراك",
    // title: this.$t("map.subscribe"),
    path: "subscribe",
    auth: true,
    type: "subscribe.png",
  },
  {
    //   title: "After Sales",
    title: "خدمة ما بعد البيع",
    // title: this.$t("map.aftersales"),
    path: "aftersales",
    auth: true,
    type: "aftersales.png",
  },
  {
    title:'getNfcode',
    // title: "홈페이지",
    // title: this.$t("map.home"),
    path: "nfcode",
    auth: true,
    type: "excode.png",
  },
  {
    //   title: "luckdraw",
    title: "السحب على الجوائز",
    // title: this.$t("map.luckdraw"),
    path: "luckdraw",
    auth: true,
    type: "luckdraw.png",
  },
  // {
  //     title:'تمنى أمنية',
  //       title: this.$t("map.wish"),
  //     path:'wish',
  //     auth:true,
  //     type:'wish.png'
  // },
  // {
  //   title: "Help Center",
  //   title: this.$t("map.helpcenter"),
  //   path: "help",
  //   auth: true,
  //   type: "help.png",
  // },
  {
    //   title: "trading stamps",
    title: "صفحة الاستبدال",
    // title: this.$t("map.tradingstamps"),
    path: "excode",
    auth: true,
    type: "excode.png",
  },
  ],
  menuListNoLoginAr: [
    {
      // title:'Home',
      title: "الصفحة الرئيسية",
      // title: this.$t("map.home"),
      path: "home",
      auth: true,
      type: "home.png",
    },
    {
      // title:'User info',
      title: "تسجيل الدخول",
      // title: this.$t("map.userinfo"),
      path: "userinfo",
      auth: true,
      type: "login.png",
    },
    {
      //   title: "With friends",
      title: "معلومات العمولة",
      // title: this.$t("map.withfriends"),
      path: "friends",
      auth: true,
      type: "friends.png",
    },
    {
      //   title: "Subscribe",
      title: "الاشتراك",
      // title: this.$t("map.subscribe"),
      path: "subscribe",
      auth: true,
      type: "subscribe.png",
    },
    {
      //   title: "After Sales",
      title: "خدمة ما بعد البيع",
      // title: this.$t("map.aftersales"),
      path: "aftersales",
      auth: true,
      type: "aftersales.png",
    },
    {
      title:'getNfcode',
      // title: "홈페이지",
      // title: this.$t("map.home"),
      path: "nfcode",
      auth: true,
      type: "excode.png",
    },
    {
      //   title: "luckdraw",
      title: "السحب على الجوائز",
      // title: this.$t("map.luckdraw"),
      path: "luckdraw",
      auth: true,
      type: "luckdraw.png",
    },
    // {
    //     title:'تمنى أمنية',
    //       title: this.$t("map.wish"),
    //     path:'wish',
    //     auth:true,
    //     type:'wish.png'
    // },
    // {
    //   title: "Help Center",
    //   title: this.$t("map.helpcenter"),
    //   path: "help",
    //   auth: true,
    //   type: "help.png",
    // },
    {
      //   title: "trading stamps",
      title: "صفحة الاستبدال",
      // title: this.$t("map.tradingstamps"),
      path: "excode",
      auth: true,
      type: "excode.png",
    },
  ],
// 英语
  menuListNoLoginEn: [
    {
      title:'Home',
      // title: "홈페이지",
      // title: this.$t("map.home"),
      path: "home",
      auth: true,
      type: "home.png",
    },
    {
      title:'Login',
      // title: "로그인",
      // title: this.$t("map.login"),
      path: "login",
      auth: true,
      type: "login.png",
    },
    {
        title: "With friends",
      // title: "연맹",
      // title: this.$t("map.withfriends"),
      path: "friends",
      auth: true,
      type: "friends.png",
    },
    {
        title: "Subscribe",
      // title: "구독하다",
      // title: this.$t("map.subscribe"),
      path: "subscribe",
      auth: true,
      type: "subscribe.png",
    },
    {
        title: "After Sales",
      // title: "고객센터",
      // title: this.$t("map.aftersales"),
      path: "aftersales",
      auth: true,
      type: "aftersales.png",
    },
    {
      title:'getNfcode',
      // title: "홈페이지",
      // title: this.$t("map.home"),
      path: "nfcode",
      auth: true,
      type: "excode.png",
    },
    {
        title: "LuckyDraw",
      // title: "추첨",
      // title: this.$t("map.luckdraw"),
      path: "luckdraw",
      auth: true,
      type: "luckdraw.png",
    },
    // {
    //     title:'Wish',
    //       title: this.$t("map.wish"),
    //     path:'wish',
    //     auth:true,
    //     type:'wish.png'
    // },
    // {
    //   title: "Help Center",
    //   title: this.$t("map.helpcenter"),
    //   path: "help",
    //   auth: true,
    //   type: "help.png",
    // },
    {
        title: "trading stamps",
      // title: "환전",
      // title: this.$t("map.tradingstamps"),
      path: "excode",
      auth: true,
      type: "excode.png",
    },
  ],
  menuListLoginEn: [
    {
      title:'Home',
      // title: "홈페이지",
      // title: this.$t("map.home"),
      path: "home",
      auth: true,
      type: "home.png",
    },
    {
      title:'User info',
      // title: "개인적인 정보",
      // title: this.$t("map.userinfo"),
      path: "userinfo",
      auth: true,
      type: "login.png",
    },
    {
        title: "With friends",
      // title: "연맹",
      // title: this.$t("map.withfriends"),
      path: "friends",
      auth: true,
      type: "friends.png",
    },
    {
        title: "Subscribe",
      // title: "구독하다",
      // title: this.$t("map.subscribe"),
      path: "subscribe",
      auth: true,
      type: "subscribe.png",
    },
    {
        title: "After Sales",
      // title: "고객센터",
      // title: this.$t("map.aftersales"),
      path: "aftersales",
      auth: true,
      type: "aftersales.png",
    },
    {
      title:'getNfcode',
      // title: "홈페이지",
      // title: this.$t("map.home"),
      path: "nfcode",
      auth: true,
      type: "excode.png",
    },
    {
        title: "luckdraw",
      // title: "추첨",
      // title: this.$t("map.luckdraw"),
      path: "luckdraw",
      auth: true,
      type: "luckdraw.png",
    },
    // {
    //     title:'Wish',
    //       title: this.$t("map.wish"),
    //     path:'wish',
    //     auth:true,
    //     type:'wish.png'
    // },
    // {
    //   title: "Help Center",
    //   title: this.$t("map.helpcenter"),
    //   path: "help",
    //   auth: true,
    //   type: "help.png",
    // },
    {
        title: "trading stamps",
      // title: "환전",
      // title: this.$t("map.tradingstamps"),
      path: "excode",
      auth: true,
      type: "excode.png",
    },
  ],
  // 意大利语
  menuListNoLoginIt: [
    {
      title:'Pagina iniziale',
      // title: "홈페이지",
      // title: this.$t("map.home"),
      path: "home",
      auth: true,
      type: "home.png",
    },
    {
      title:'Accedi',
      // title: "로그인",
      // title: this.$t("map.login"),
      path: "login",
      auth: true,
      type: "login.png",
    },
    {
        title: "con amici",
      // title: "연맹",
      // title: this.$t("map.withfriends"),
      path: "friends",
      auth: true,
      type: "friends.png",
    },
    {
        title: "Abbonamento",
      // title: "구독하다",
      // title: this.$t("map.subscribe"),
      path: "subscribe",
      auth: true,
      type: "subscribe.png",
    },
    {
        title: "Dopovendita",
      // title: "고객센터",
      // title: this.$t("map.aftersales"),
      path: "aftersales",
      auth: true,
      type: "aftersales.png",
    },
    {
      title:'getNfcode',
      // title: "홈페이지",
      // title: this.$t("map.home"),
      path: "nfcode",
      auth: true,
      type: "excode.png",
    },
    {
        title: "Sorteggio fortunato",
      // title: "추첨",
      // title: this.$t("map.luckdraw"),
      path: "luckdraw",
      auth: true,
      type: "luckdraw.png",
    },
    // {
    //     title:'Wish',
    //       title: this.$t("map.wish"),
    //     path:'wish',
    //     auth:true,
    //     type:'wish.png'
    // },
    // {
    //   title: "Help Center",
    //   title: this.$t("map.helpcenter"),
    //   path: "help",
    //   auth: true,
    //   type: "help.png",
    // },
    {
        title: "Lista di riscatto",
      // title: "환전",
      // title: this.$t("map.tradingstamps"),
      path: "excode",
      auth: true,
      type: "excode.png",
    },
  ],
  menuListLoginIt: [
    {
      title:'Pagina iniziale',
      // title: "홈페이지",
      // title: this.$t("map.home"),
      path: "home",
      auth: true,
      type: "home.png",
    },
    {
      title:"Informazioni dell'utente",
      // title: "개인적인 정보",
      // title: this.$t("map.userinfo"),
      path: "userinfo",
      auth: true,
      type: "login.png",
    },
    {
        title: "con amici",
      // title: "연맹",
      // title: this.$t("map.withfriends"),
      path: "friends",
      auth: true,
      type: "friends.png",
    },
    {
        title: "Abbonamento",
      // title: "구독하다",
      // title: this.$t("map.subscribe"),
      path: "subscribe",
      auth: true,
      type: "subscribe.png",
    },
    {
        title: "Dopovendita",
      // title: "고객센터",
      // title: this.$t("map.aftersales"),
      path: "aftersales",
      auth: true,
      type: "aftersales.png",
    },
    {
      title:'getNfcode',
      // title: "홈페이지",
      // title: this.$t("map.home"),
      path: "nfcode",
      auth: true,
      type: "excode.png",
    },
    {
        title: "Sorteggio fortunato",
      // title: "추첨",
      // title: this.$t("map.luckdraw"),
      path: "luckdraw",
      auth: true,
      type: "luckdraw.png",
    },
    // {
    //     title:'Wish',
    //       title: this.$t("map.wish"),
    //     path:'wish',
    //     auth:true,
    //     type:'wish.png'
    // },
    // {
    //   title: "Help Center",
    //   title: this.$t("map.helpcenter"),
    //   path: "help",
    //   auth: true,
    //   type: "help.png",
    // },
    {
        title: "Lista di riscatto",
      // title: "환전",
      // title: this.$t("map.tradingstamps"),
      path: "excode",
      auth: true,
      type: "excode.png",
    },
  ],
  // 西班牙语
  menuListNoLoginEs: [
    {
      title:'Primera página',
      // title: "홈페이지",
      // title: this.$t("map.home"),
      path: "home",
      auth: true,
      type: "home.png",
    },
    {
      title:'Acceso',
      // title: "로그인",
      // title: this.$t("map.login"),
      path: "login",
      auth: true,
      type: "login.png",
    },
    {
        title: "con amigos",
      // title: "연맹",
      // title: this.$t("map.withfriends"),
      path: "friends",
      auth: true,
      type: "friends.png",
    },
    {
        title: "Suscripción",
      // title: "구독하다",
      // title: this.$t("map.subscribe"),
      path: "subscribe",
      auth: true,
      type: "subscribe.png",
    },
    {
        title: "Después de las ventas",
      // title: "고객센터",
      // title: this.$t("map.aftersales"),
      path: "aftersales",
      auth: true,
      type: "aftersales.png",
    },    {
      title:'getNfcode',
      // title: "홈페이지",
      // title: this.$t("map.home"),
      path: "nfcode",
      auth: true,
      type: "excode.png",
    },
    {
        title: "Sorteo de la suerte",
      // title: "추첨",
      // title: this.$t("map.luckdraw"),
      path: "luckdraw",
      auth: true,
      type: "luckdraw.png",
    },
    // {
    //     title:'Wish',
    //       title: this.$t("map.wish"),
    //     path:'wish',
    //     auth:true,
    //     type:'wish.png'
    // },
    // {
    //   title: "Help Center",
    //   title: this.$t("map.helpcenter"),
    //   path: "help",
    //   auth: true,
    //   type: "help.png",
    // },
    {
        title: "Lista de canje",
      // title: "환전",
      // title: this.$t("map.tradingstamps"),
      path: "excode",
      auth: true,
      type: "excode.png",
    },
  ],
  menuListLoginEs: [
    {
      title:'Primera página',
      // title: "홈페이지",
      // title: this.$t("map.home"),
      path: "home",
      auth: true,
      type: "home.png",
    },
    {
      title:"Informacion del usuario",
      // title: "개인적인 정보",
      // title: this.$t("map.userinfo"),
      path: "userinfo",
      auth: true,
      type: "login.png",
    },
    {
        title: "con amigos",
      // title: "연맹",
      // title: this.$t("map.withfriends"),
      path: "friends",
      auth: true,
      type: "friends.png",
    },
    {
        title: "Suscripción",
      // title: "구독하다",
      // title: this.$t("map.subscribe"),
      path: "subscribe",
      auth: true,
      type: "subscribe.png",
    },
    {
        title: "Después de las ventas",
      // title: "고객센터",
      // title: this.$t("map.aftersales"),
      path: "aftersales",
      auth: true,
      type: "aftersales.png",
    },
    {
      title:'getNfcode',
      // title: "홈페이지",
      // title: this.$t("map.home"),
      path: "nfcode",
      auth: true,
      type: "excode.png",
    },
    {
        title: "Sorteo de la suerte",
      // title: "추첨",
      // title: this.$t("map.luckdraw"),
      path: "luckdraw",
      auth: true,
      type: "luckdraw.png",
    },
    // {
    //     title:'Wish',
    //       title: this.$t("map.wish"),
    //     path:'wish',
    //     auth:true,
    //     type:'wish.png'
    // },
    // {
    //   title: "Help Center",
    //   title: this.$t("map.helpcenter"),
    //   path: "help",
    //   auth: true,
    //   type: "help.png",
    // },
    {
        title: "Lista de canje",
      // title: "환전",
      // title: this.$t("map.tradingstamps"),
      path: "excode",
      auth: true,
      type: "excode.png",
    },
  ],
    // 法语
  menuListNoLoginFr: [
      {
        title:'Accueil',
        // title: "홈페이지",
        // title: this.$t("map.home"),
        path: "home",
        auth: true,
        type: "home.png",
      },
      {
        title:'se connecter',
        // title: "로그인",
        // title: this.$t("map.login"),
        path: "login",
        auth: true,
        type: "login.png",
      },
      {
          title: "avec nos amis",
        // title: "연맹",
        // title: this.$t("map.withfriends"),
        path: "friends",
        auth: true,
        type: "friends.png",
      },
      {
          title: "S'abonner à",
        // title: "구독하다",
        // title: this.$t("map.subscribe"),
        path: "subscribe",
        auth: true,
        type: "subscribe.png",
      },
      {
          title: "Service après-vente ",
        // title: "고객센터",
        // title: this.$t("map.aftersales"),
        path: "Tirer au sort un prix",
        auth: true,
        type: "aftersales.png",
      },    {
        title:'getNfcode',
        // title: "홈페이지",
        // title: this.$t("map.home"),
        path: "nfcode",
        auth: true,
        type: "excode.png",
      },
      {
          title: "tirer au sort un prix",
        // title: "추첨",
        // title: this.$t("map.luckdraw"),
        path: "luckdraw",
        auth: true,
        type: "luckdraw.png",
      },
      // {
      //     title:'Wish',
      //       title: this.$t("map.wish"),
      //     path:'wish',
      //     auth:true,
      //     type:'wish.png'
      // },
      // {
      //   title: "Help Center",
      //   title: this.$t("map.helpcenter"),
      //   path: "help",
      //   auth: true,
      //   type: "help.png",
      // },
      {
        title: "page d'échange",
        // title: "환전",
        // title: this.$t("map.tradingstamps"),
        path: "excode",
        auth: true,
        type: "excode.png",
      },
    ],
  menuListLoginFr: [
      {
        title:"Accueil",
        // title: "홈페이지",
        // title: this.$t("map.home"),
        path: "home",
        auth: true,
        type: "home.png",
      },
      {
        title:"informations d'utilisateur",
        // title: "개인적인 정보",
        // title: this.$t("map.userinfo"),
        path: "userinfo",
        auth: true,
        type: "login.png",
      },
      {
          title: "avec nos amis",
        // title: "연맹",
        // title: this.$t("map.withfriends"),
        path: "friends",
        auth: true,
        type: "friends.png",
      },
      {
          title: "S'abonner à",
        // title: "구독하다",
        // title: this.$t("map.subscribe"),
        path: "subscribe",
        auth: true,
        type: "subscribe.png",
      },
      {
          title: "Service après-vente",
        // title: "고객센터",
        // title: this.$t("map.aftersales"),
        path: "aftersales",
        auth: true,
        type: "aftersales.png",
      },
      {
        title:'getNfcode',
        // title: "홈페이지",
        // title: this.$t("map.home"),
        path: "nfcode",
        auth: true,
        type: "excode.png",
      },
      {
      title: "Tirer au sort un prix",
        // title: "추첨",
        // title: this.$t("map.luckdraw"),
        path: "luckdraw",
        auth: true,
        type: "luckdraw.png",
      },
      // {
      //     title:'Wish',
      //       title: this.$t("map.wish"),
      //     path:'wish',
      //     auth:true,
      //     type:'wish.png'
      // },
      // {
      //   title: "Help Center",
      //   title: this.$t("map.helpcenter"),
      //   path: "help",
      //   auth: true,
      //   type: "help.png",
      // },
      {
        title: "page d'échange",
        // title: "환전",
        // title: this.$t("map.tradingstamps"),
        path: "excode",
        auth: true,
        type: "excode.png",
      },
    ],
};

const getters = {
  getMenuListData: (state) => state.menuList,
};

// mutations主要用来操作state
const mutations = {
  setMenuListData(state, data) {
    state.menuList = data;
  },
};

export default {
  state,
  getters,
  mutations,
};
